import { Select, Spin } from "antd";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { ISelectOption } from "../../models/utils/selectOption";
import { defaultFilterOption } from "../../utils";
import { useGetDataOnScroll } from "../getDataOnScrollProps/useGetDataOnScrollProps";
import { getCookie } from "typescript-cookie";
import { useLazyGetTransportTypeListQuery } from "../../redux/api/handBooksApi/transportTypesApi";
import { EntTypeTransport } from "../../models/handBooks/typeTransport";
import { EntTypeTransportFilter } from "../../models/filters/typeTransportFilter";

interface IProps {
  value?: number | null;
  onChange?: (v: number) => void;
}
const SelectMultiTypeTransport = (props: IProps) => {
  const { t } = useTranslation();
  const [options, setOptions] = useState<ISelectOption[]>([]);
  const [getData] = useLazyGetTransportTypeListQuery();
  const {
    fetching,
    data,
    setData,
    setFetching,
    setFilter,
    scrollHandler,
    setCurrentPage
  } = useGetDataOnScroll<EntTypeTransport, EntTypeTransportFilter>({
    initialFilter: new EntTypeTransportFilter(),
    query: getData
  });

  useEffect(() => {
    const options = Array.from(new Set(data)).map((a) => {
      return { label: getCookie('i18next') === 'ky' ? `${a.nameKy}` : `${a.nameRu}` , value: a.id ?? '' };
    });
    setOptions(options);
  }, [data]);

  const search = (value?: string) => {
    if (!value) return;
    const filter = new EntTypeTransportFilter();
    filter.name = value;
    setFilter(filter);
    setData([]);
    setCurrentPage(0);
    setFetching(true);
  }
  const clear = () => {
    const filter = new EntTypeTransportFilter();
    filter.name = null; 
    setFilter(filter);
    setData([]);
    setCurrentPage(0);
    setFetching(true);
  }
  return (
    <Select
            mode="multiple"
      placeholder={t("msg.selectPlaceholder")}
      onClear={clear}
            onSearch={search}
      onPopupScroll={scrollHandler}
      loading={fetching}
      value={props.value}
      onChange={props.onChange}
      options={options}
      filterOption={defaultFilterOption}
      showSearch
      allowClear
      dropdownRender={(menu) => (
        <Spin spinning={fetching}>
          {menu}
        </Spin>
      )}
    />
  );
};

export default SelectMultiTypeTransport;
